import {NavList} from '@primer/react'
import {artifactRegistryIndexRoute} from '../routes/artifact-registry-route'

interface SidebarNavProps {
  organization: string
  selectedTab: 'github_packages' | 'linked_artifacts'
}

export function SidebarNav({organization, selectedTab}: SidebarNavProps) {
  return (
    <nav aria-label="Packages" className="px-2">
      <h3 className="tmp-pl-3 tmp-pt-4">Packages</h3>
      <NavList>
        <NavList.Item
          href={`/orgs/${organization}/packages`}
          aria-current={selectedTab === 'github_packages' ? 'page' : undefined}
        >
          GitHub Packages
        </NavList.Item>
        <NavList.Item
          href={artifactRegistryIndexRoute.generatePath({org: organization})}
          aria-current={selectedTab === 'linked_artifacts' ? 'page' : undefined}
        >
          Linked artifacts
        </NavList.Item>
      </NavList>
    </nav>
  )
}
